import { render, staticRenderFns } from "./BillDetailsPage.vue?vue&type=template&id=54cb4c32&scoped=true"
import script from "./BillDetailsPage.vue?vue&type=script&lang=js"
export * from "./BillDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./BillDetailsPage.vue?vue&type=style&index=0&id=54cb4c32&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb4c32",
  null
  
)

export default component.exports